import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { cloneDeep } from 'lodash';
import { map } from 'rxjs/operators';
import { of } from 'rxjs/observable/of';

import { HttpInterceptorService } from '../../core/services/http-interceptor.service';
import { NavigationConfigService } from '@ispm/navigation/services/navigationConfig.service';
import { ResourceHelperService } from './resource-helper.services';
import { TherapiesService } from '@ispm/therapies/services/therapies.service';

@Injectable()
export class ResourceService extends ResourceHelperService {
  public static baseResourceUrl = '/api/v2/resource';

  protected _type = 'patient';

  constructor(
    protected _http: HttpInterceptorService,
    protected _navigationConfigService: NavigationConfigService
  ) {
    super(_http, _navigationConfigService);
  }

  public getTotalEntities() {
    return this._http.get(`${ResourceService.baseResourceUrl}/entityCount/${this._type}`)
      .pipe(
        map(data => data.json()),
      );
  }

  public getResource(field_list, resources_ids) {
    return this._http.post(
      ResourceService.baseResourceUrl + `/data/${this._type.toLowerCase()}`,
      { resources_ids, field_list }
      )
      .pipe(
        map(data => data.json()),
      );
  }

  public getResourceIds(query: any, page: number, sortField: string, sortOrder: string | number, hasSearchMode, isClubbed?: boolean, configTemplateType?: string, resourceType?: string, patientIds?: string) {
    const order = (sortOrder === 1) ? 'asc' : 'desc';
    query = cloneDeep(query);
    query._sortField = sortField;
    query._sortOrder = order;
    query.page = page;
    query.chunkSize = this._chunkAmount;
    query.searchFetch = hasSearchMode || false;
    delete query._countOnly;

    return this._http.get(ResourceService.baseResourceUrl + `/ids/${this._type}`, query)
      .pipe(
        map(data => data.json()),
      )
      .catch(err => {
        return Observable.throw(err);
      });
  }

  public getResourceIdsPatientTests(patientId: string, orgId: string) {
    return this._http.get(`/workflow/extended/worklist?id=$(OrganizationId),${patientId}`)
      .pipe(
        map((data: any) => data.json()),
      )
      .catch((err) => {
        return Observable.throw(err);
      });
  }

  public getTreatments(patientId: string, revision: string) {
    const params: any = {
      context: `${patientId},${revision}`
    };

    return this._http.get(TherapiesService.treatmentsURLSuffix, params, false)
      .map(res => res.json())
      .catch(err => {
        return Observable.throw(err);
      });
  }

  public getSelectedTreatment(revision: string) {
    return this._http.post(`${TherapiesService.therapiesURLSuffix}/searchPriorities`, { context: revision })
      .map(res => res.json())
      .catch(err => {
        return Observable.throw(err);
      });
  }

  public getQuery(
    page: number,
    sortField: string,
    sortOrder: string | number,
    sortByType: string,
    sortPath: boolean,
    associationItems?: Array<any>,
    adaptableFilters?: any,
    resourceIds?: string
  ) {
    return of({ });
  }
}
